module.exports = __webpack_public_path__ + "media/couriers/omniva_logo-d1da7a92.png";